<template>
  <!--<div>-->
  <div class="mobileBox">
    <!--banner+导航-->
    <div class="topBanner">
      <img class="bannerImg" src="../../../assets/img/serviceBanner_m.png"/>


      <top-nav></top-nav>


    </div>

    <div class="servicesContent" id="m1">
      <div class="services01 animated" :class="animates.mm1 ? 'fadeInUp' : 'hideBox'">
        <div class="text1">WeChat Moment Ads</div>
        <div class="text2">Let the Ads exist when needed.</div>
        <div class="btns" @click="navClick('/apply_m')">CONTACT</div>
        <div class="imgs"><img src="../../../assets/icon/servicesImg1.png"/></div>
      </div>
      <div class="services01"  id="m2">
        <div class="animated" :class="animates.mm2 ? 'fadeInUp' : 'hideBox'">
        <div class="text1">Payment Successful Page Ads</div>
        <div class="text2">More than 10000 transactions per day, WeChat platform promotion. </div>
        <div class="btns" @click="navClick('/apply_m')">CONTACT</div>
        <div class="imgs"><img src="../../../assets/icon/servicesImg2.png"/></div>
        </div>
      </div>

      <div class="services02" id="m3">
        <div class="animated" :class="animates.mm3 ? 'fadeInUp' : 'hideBox'">
        <div class="title1">Multi-Platform Campaign</div>
        <ul class="servicesUl">
          <li class="servicesLi">
            <div class="iconBox"><img src="../../../assets/icon/servicesIcon1.png"/></div>
            <div class="textBox">
              <div class="title2">Alipay Red Pocket</div>
              <div class="texts">Scan the QR code and Alipay will send customers a random amount of money to use in future purchase.</div>
            </div>
          </li>
          <li class="servicesLi">
            <div class="iconBox"><img src="../../../assets/icon/servicesIcon2.png"/></div>
            <div class="textBox">
              <div class="title2">WeChat Pay Lucky Money</div>
              <div class="texts">WeChat will send customers a random amount of money to use in their e-wallet before purchase.</div>
            </div>
          </li>
          <li class="servicesLi">
            <div class="iconBox"><img src="../../../assets/icon/servicesIcon3.png"/></div>
            <div class="textBox">
              <div class="title2">Festival Campaigns</div>
              <div class="texts">Both Alipay and WeChat Pay offer multiple festival campaigns for customers to earn real money by scanning the campaign code.</div>
            </div>
          </li>
        </ul>
        </div>
      </div>

      <div class="services02" id="m4">
        <div class="animated" :class="animates.mm4 ? 'fadeInUp' : 'hideBox'">
        <div class="title1">WeChat Pay promotion</div>
        <ul class="servicesUl">
          <li class="servicesLi">
            <div class="iconBox"><img src="../../../assets/icon/servicesIcon4.png"/></div>
            <div class="textBox">
              <div class="title2">WeChat Moments Ads</div>
              <div class="texts">Apply WeChat Moments Ad to expand your brand reach to 2,900,000 active WeChat users in Australia.</div>
            </div>
          </li>
          <li class="servicesLi">
            <div class="iconBox"><img src="../../../assets/icon/servicesIcon5.png"/></div>
            <div class="textBox">
              <div class="title2">Payment Successful Page Ads</div>
              <div class="texts">Advertise on WeChat Pay payment successful page for over 10,000 exposures per day.</div>
            </div>
          </li>
          <li class="servicesLi">
            <div class="iconBox"><img src="../../../assets/icon/servicesIcon6.png"/></div>
            <div class="textBox">
              <div class="title2">Gift Pack Mini Program</div>
              <div class="texts">It is a mini program that WeChat Pay released to overseas market, which contains deals and offers provided by both merchants and WeChat Pay.</div>
            </div>
          </li>
        </ul>
        </div>
      </div>

      <div class="services02" id="m5">
        <div class="animated" :class="animates.mm5 ? 'fadeInUp' : 'hideBox'">
        <div class="title1">Alipay promotion</div>
        <ul class="servicesUl">
          <li class="servicesLi">
            <div class="iconBox"><img src="../../../assets/icon/servicesIcon7.png"/></div>
            <div class="textBox">
              <div class="title2">Alipay Discover Promotion</div>
              <div class="texts">Merchant listing in Alipay Discover platform can have detailed description of the store location, customer's review and special offers displayed and pushed in the user’s Alipay App.</div>
            </div>
          </li>
          <li class="servicesLi">
            <div class="iconBox"><img src="../../../assets/icon/servicesIcon8.png"/></div>
            <div class="textBox">
              <div class="title2">Alipay City Card</div>
              <div class="texts">Merchants can provide offers and it will be listed on the Alipay City Card, which is one of the most popular Alipay promotion platforms.</div>
            </div>
          </li>
          <li class="servicesLi">
            <div class="iconBox"><img src="../../../assets/icon/servicesIcon9.png"/></div>
            <div class="textBox">
              <div class="title2">Alipay Week</div>
              <div class="texts">Each week Alipay offers different promotion, one for twenty, spend one CNY to exchange a 20 CNY coupon.</div>
            </div>
          </li>
        </ul>
        </div>
      </div>

    </div>

    <!--底部-->
    <div class="footer_m ">
      <div class="footer_mText">
        Supay Technology Pty Ltd. Authorized Representative Number 001283947
        <div class="goTopBtn" @click="toTop"><img src="../../../assets/icon/goTopIcon.png"/></div>
      </div>
    </div>

  </div>
  <!--</div>-->
</template>

<script>
  import topNav from './nav_m'
  let timer = null; //定义初始值
  export default {
    name: "services_m",
    components:{topNav},
    props:{
      step:{   //此数据是控制动画快慢的
        type:Number,
        default:50
      }
    },
    data() {
      return {
        animates:{
          mm1:false,
          mm2:false,
          mm3:false,
          mm4:false,
          mm5:false,
        },
      }
    },
    destroyed(){
      window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
    },
    mounted () {
      document.documentElement.scrollTop=0;

      this.animates.mm1 = true;
      window.addEventListener('scroll', this.handleScroll)
    },
    methods:{
      //  点击导航
      navClick(url){
        this.$router.push(url);
      },

      handleScroll () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

        // var offsetTop1 = document.querySelector('#m1').offsetTop;
        var offsetTop2 = document.querySelector('#m2').offsetTop;
        var offsetTop3 = document.querySelector('#m3').offsetTop;
        var offsetTop4 = document.querySelector('#m4').offsetTop;
        var offsetTop5 = document.querySelector('#m5').offsetTop;



        if (scrollTop > offsetTop2-800) {
          this.animates.mm2 = true
        } else {
          // this.animates.mm2 = false
        }
        if (scrollTop > offsetTop3-800) {
          this.animates.mm3 = true
        } else {
          // this.animates.mm3 = false
        }
        if (scrollTop > offsetTop4-800) {
          this.animates.mm4 = true
        } else {
          // this.animates.mm4 = false
        }
        if (scrollTop > offsetTop5-800) {
          this.animates.mm5 = true
        } else {
          // this.animates.mm5 = false
        }
      },

      //置顶
      toTop(){ // 动画

        timer = setInterval(function () {
          let osTop = document.documentElement.scrollTop || document.body.scrollTop;
          let ispeed = Math.floor(-osTop / 5);
          document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
          // this.isTop = true
          if (osTop === 0) {
            clearInterval(timer)
          }
        },30)

      },
    }
  }
</script>

<style scoped>
  .mobileBox{width: 100%;height: auto;}
  .mobileBox .topBanner{width: 100%;height: auto;position: relative;}
  .mobileBox .topBanner .bannerImg{width: 100%;height: auto;}

  .servicesContent{width: 100%;height: auto;}

  /*板块1*/
  .services01{width: calc(100% - 30px);height: auto;margin: auto;}
  .services01:nth-of-type(1){border-bottom: 2px solid #c1c1c1;}
  .services01 .text1{
    font-size: 1.5rem;
    font-family: MontserratRegular;
    color: #4a4a4a;
    /*line-height: 2rem;*/
    margin-top: 2rem;
    width: 100%;
    padding: 10px 0;
    text-align: center;
  }
  .services01 .text2{
    font-size: 0.75rem;
    font-family: Montserrat300;
    color: #4a4a4a;
    width: 100%;
    padding: 10px 0;
    text-align: center;
  }
  .services01 .btns{
    font-size: 0.75rem;
    width: 5.7rem;
    font-family: MontserratMedium;
    text-align: center;
    color: #4a4a4a;
    height: 1.875rem;
    line-height: 1.875rem;
    margin: 2rem auto;
    border: 1px solid #4a4a4a;
    border-radius: 4px;
    cursor: pointer;
  }
  .services01 .imgs{
    width: 80%;
    height: auto;
    margin: auto;
  }
  .services01 .imgs>img{width: 100%;}


  /*板块2*/
  .services02{width: calc(100% - 30px);background-color: #f6f6f6;padding: 1.5rem 15px;}
  .services02 .title1{width: 100%;
    padding: 1rem 0;
    font-family: Montserrat300;
    font-size: 1.5rem;
    text-align: center;
    border-bottom: 1px solid #979797;}
  .services02 .servicesUl{
    width: 100%;
    height: auto;
    padding: 10px 0;
  }
  .services02 .servicesUl .servicesLi{
    width: 100%;
    padding: 20px 0;
    height: auto;
    position: relative;
  }
  .services02 .servicesUl .servicesLi .iconBox{
    width: 20%;
    position: absolute;
    text-align: center;
  }
  .services02 .servicesUl .servicesLi .iconBox>img{
    transform: scale(0.8);
  }
  .services02 .servicesUl .servicesLi .textBox{
    padding-left: 20%;
    width: 80%;
  }
  .services02 .servicesUl .servicesLi .textBox .title2{
    width: 100%;
    height: auto;
    font-family: Montserrat600;
    font-size: 1rem;
    color: #4a4a4a;
    line-height: 2rem;
  }
  .services02 .servicesUl .servicesLi .textBox .texts{
    width: 100%;
    height: auto;
    font-family: Montserrat300;
    font-size: 0.875rem;
    color: #4a4a4a;
    line-height: 1.3rem;
  }





  .hideBox{display: none;}

</style>
